import dayjs from "dayjs";

export const requestForTableCharts = (time: string[], tableCharts: string) => {
    return {
        from_date: time[0],
        to_date: dayjs(time[1]).day(6).format('YYYY-MM-DD'),
        table_category: (tableCharts === 'Динамика количества товаров в каталоге' ? '' : tableCharts) // конечная дата + конец недели
    }
}